import { put, call, takeLatest } from "redux-saga/effects";
import { LOGIN_URL } from "../../service/apiUrl";
import { postApiCall } from "../../service/PostApiCall";
import { hasAuthToken } from "../../service/apiError";
import Utils from "../../utility/utility";
import { STRING } from "../../constants/string";
import { actionSigninError, actionSigninSuccess } from "../action/signinAction";
import { SIGNIN_REQUEST } from "../actionType/type";

function* signinSaga(action){
    try {
        const response = yield call(postApiCall,action?.params,action?.params?.access_token,LOGIN_URL)

        /* Every request in the app signs itself with this token. Storing a
           response without one produces a session that renders as logged in
           and then 401s on every call, so it is refused here. */
        if (!hasAuthToken(response?.access_token)) {
            const tokenless = { data: { message: STRING.LOGIN_NO_TOKEN } };
            Utils.toast('error',STRING.LOGIN_NO_TOKEN);
            yield put(actionSigninError(tokenless));
            if (action.onError) action.onError(tokenless)
            return
        }

        yield put(actionSigninSuccess(response));
        action.onSuccess(response)
    } catch (error) {
        Utils.toast('error',error?.data?.message);
        yield put(actionSigninError(error));
        if (action.onError) action.onError(error)
    }
}

export function* watchSigninSaga(){
    yield takeLatest(SIGNIN_REQUEST,signinSaga)
}